import { client, errorValidation } from "./service";

export const getAdminList = async function () {
    try {
        let response = await client.get(`/admin/list`);
        console.log('here response', response)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const getAdmin = async function ({
    id
}) {
    try {
        let response = await client.get(`/admin/detail/${id}`);
        console.log('here response', response)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const createAdmin = async function ({
    name, username, password, role, isActive
}) {
    try {
        let response = await client.post(`/admin/create`, {
            name, username, password, role, isActive
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const updateAdmin = async function ({
    _id, name, username, password, role, isActive
}) {
    try { 
        let response = await client.post(`/admin/update`, {
            _id, name, username, password, role, isActive
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const deleteAdmin = async function ({
    adminId
}) {
    try {
        let response = await client.delete(`/admin/delete/${adminId}`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const changePasswordService = async function ({
    _id, oldPassword, password
}) {
    try { 
        let response = await client.post(`/profile/change-password/${_id}`, {
            oldPassword, password
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}